import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Typography } from 'antd';
import { getChannelList } from '../../../skills_action';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { accessInfo } from 'components/skills/cardSkill/report_actions';
import MemberSelect from 'components/common/memberSelect';

const { Text } = Typography;

const ReportAccess = (props) => {
  const dispatch = useDispatch();
  const reportAccessMembersData = useSelector(
    (state) => state.report.reportAccessMembers
  );
  const [reportAccessMembers, setReportAccessMembers] = useState(
    reportAccessMembersData ? reportAccessMembersData : []
  );

  const getUserIdFromArrays = (selectedMembers, membersList) => {
    return selectedMembers.map((element) => {
      const mongoIdRegex = /^[0-9a-fA-F]{24}$/; // Regex to match a MongoDB ObjectID
      if (mongoIdRegex.test(element)) {
        return element;
      }

      const matchedItem = membersList.find((item) => {
        return (
          element === item.slackInfo.displayName ||
          element === item.slackInfo.name ||
          element === item.slackInfo.user_name
        );
      });

      return matchedItem ? matchedItem.user_id : null;
    });
  };

  const onChange = (val) => {
    const memberIds = getUserIdFromArrays(val, props.membersList);
    dispatch(accessInfo(memberIds));
    setReportAccessMembers(val);
  };

  const checkIfReportContainsUserIdOrUserObj = (members) => {
    let memberArrWithIds =
      members &&
      members.map((member) => {
        if (member) {
          const selectedMember =
            props.membersList &&
            props.membersList.find(
              (memberItem) => memberItem.user_id === member
            );
          if (selectedMember && selectedMember.slackInfo) {
            return (
              selectedMember.slackInfo.displayName ||
              selectedMember.slackInfo.name ||
              selectedMember.slackInfo.user_name
            );
          } else {
            return (
              member.displayName ||
              member.name ||
              member.user_name ||
              member.email ||
              member
            );
          }
        }
      });
    return memberArrWithIds;
  };

  return (
    <div style={{ display: 'flex', marginBottom: 14, alignItems: 'center' }}>
      <MemberSelect
        placeholder='Select Members'
        optionFilterProp='children'
        mode='multiple'
        onChange={(val) => onChange(val)}
        showSearch
        value={checkIfReportContainsUserIdOrUserObj(reportAccessMembers)}
        defaultUsers={reportAccessMembers || reportAccessMembersData}
        style={{ width: '100%' }}
        excludeCurrentUser={true}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    allUsers: state.skills.members,
    accessInfo: state.report.reportAccessMembers,
  };
};

export default withRouter(
  connect(mapStateToProps, { getChannelList })(ReportAccess)
);
